"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Button } from "./ui/button";
import { useRouter } from "next/navigation";
import { useCookiesAccepted } from "@/hooks/useCookiesAccepted";

export function CookieBanner() {
  const router = useRouter();
  const { cookiesAccepted, setCookiesAccepted } = useCookiesAccepted();
  const [isVisible, setIsVisible] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (cookiesAccepted === undefined) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
    setIsInitialized(true);
  }, [cookiesAccepted]);

  const handleAccept = () => {
    setCookiesAccepted(true);
    setIsVisible(false);
    router.refresh();
  };

  const handleReject = () => {
    setCookiesAccepted(false);
    setIsVisible(false);
  };

  if (!isInitialized) return null;

  return (
    <>
      {isVisible && (
        <div className="rounded-xl flex flex-col fixed bottom-6 left-6 right-6 bg-white border border-gray-300 shadow-md p-8 z-50 md:max-w-96">
          <div className="max-w-4xl mx-auto flex justify-between items-center">
            <p className="text-gray-800 text-sm mb-4">
              We use cookies to enhance your experience, analyze site traffic, and deliver
              personalized content. Read our{" "}
              <Link href="/cookies-policy" className="text-blue-700 hover:underline">
                Cookie Policy
              </Link>
              .
            </p>
          </div>

          <div className="flex space-x-2 justify-between">
            <Button
              className="border rounded-lg border-black w-[50%]"
              onClick={handleReject}>
              Reject
            </Button>
            <Button
              className="bg-black text-white w-[50%] py-2 px-4 rounded-lg hover:bg-gray-800"
              onClick={handleAccept}>
              Accept
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
